import * as React from 'react';
import { useSelector } from 'react-redux';

import { getJsonQuery } from '../../../selectors/getJsonQuery';
import { ISimplifieldTGBBannerContext } from '../../../types/adfox';
import { TGSimplifieldBannerWrapper } from '../../components/adfox/new/TGSimplifieldBannerWrapper';
import { ResidentialNativeTGBBanner } from './ResidentialNativeTGBBanner';

export interface INativeTGBBannerContainerProps {
  context: ISimplifieldTGBBannerContext;
}

export function NativeTGBBannerContainer({ context }: INativeTGBBannerContainerProps) {
  const jsonQuery = useSelector(getJsonQuery);

  const locationId = React.useMemo(() => (jsonQuery.region ? jsonQuery.region.value[0] : undefined), [jsonQuery]);

  return (
    <TGSimplifieldBannerWrapper>
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      <ResidentialNativeTGBBanner context={context as any} locationId={locationId} />
    </TGSimplifieldBannerWrapper>
  );
}
